import "./LoginPage.css";

import LoginForm from "../Components/Forms/loginForm";

const LoginPage = ({ firmSlug, branding }) => {
  return (
    <>
      <LoginForm firmSlug={firmSlug} branding={branding} />
    </>
  );
};

export default LoginPage;
